import { useTranslation } from "react-i18next";
import { FormSectionComponent } from "./FormSectionComponent";
import { TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormKeys } from "../helpers";
import {
  WORK_AGREEMENT_ACCEPTED,
  WORK_AGREEMENT_DECLINED,
} from "../../../../constants";

export const AdditionalInfo = () => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();

  const status = getValues("status");
  const isReadOnly: boolean =
    status === WORK_AGREEMENT_ACCEPTED || status === WORK_AGREEMENT_DECLINED;

  const rows = [
    {
      title: t("common:additionalInfo"),
      component: (
        <Controller
          control={control}
          name={FormKeys.ExtraInformation}
          render={({ field: { name, value, onChange } }) => (
            <TextField
              name={name}
              value={value}
              onChange={onChange}
              disabled={isReadOnly}
              size="small"
              fullWidth
            />
          )}
        />
      ),
    },
  ];

  return (
    <FormSectionComponent
      title={t("order:additionalInfoForEmploymentContractTitle")}
      rows={rows}
    />
  );
};
